import {gql} from '@apollo/client';

export const GET_SORTER_PLAN_DETAIL = gql`
    query GetSorterPlanDetail($id: Long!) {
        getSorterPlanDetail(id: $id) {
            id
            sorterId
            sorterName
            sorterType
            warehouseId
            isSortingHub
            sorterPlanName
            status
            version
            isDropBag
            isSpecified
            printCount
            ppmodBagContainerId
            isUseBatch
            canUseBatch
            disabledChuteConfig
            fallbackChuteConfig
            chuteConfigs {
                id
                chuteCode
                leadChuteId
                matchesChuteIds
                chuteType
                exceptionCodes
                carrierCode
                sortingCode
                businessType
                printType
                ttBizType
                preSortingCode
                lastMileSortingCode
                isUse
            }
        }
    }
`;

export interface ChuteConfig {
    id?: number;
    chuteCode?: string | null;
    leadChuteId?: number | null;
    matchesChuteIds?: string | null;
    chuteType: number | null;
    exceptionCodes: string[] | null;
    carrierCode?: number | null;
    sortingCode?: string | null;
    businessType?: number | null;
    printType?: number | null;
    ttBizType?: string | null;
    preSortingCode?: string | null;
    lastMileSortingCode?: string | null;
    isUse?: boolean;
}

export interface SorterPlanDetail {
    id: number;
    sorterId?: number;
    sorterName?: string;
    sorterType?: number;
    warehouseId?: number;
    /** 作业仓是否分拣仓 */
    isSortingHub?: boolean;
    sorterPlanName?: string;
    status: number;
    version: number;
    isDropBag: boolean;
    isSpecified: boolean;
    printCount: number;
    /** PPMode 容器类型（bag_container.id），null-未配置 */
    ppmodBagContainerId?: number | null;
    isUseBatch: boolean;
    /** 作业仓是否尾程仓（批次只在尾程仓使用），false 时不显示「使用批次」开关 */
    canUseBatch: boolean;
    disabledChuteConfig?: string;
    /** 兜底格口号（来自分拣机配置）；为空表示该设备无兜底格口 */
    fallbackChuteConfig?: string | null;
    chuteConfigs?: ChuteConfig[];
}

